import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalstorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class EmpGuardService {

  constructor(private router: Router, private localstorageService: LocalstorageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean{
    let url: string = state.url;
    return this.verifyEmployee(url);
  }

  verifyEmployee(url: string){
    if(this.localstorageService.isVerified()){

      return true;
    }

    this.localstorageService.requestedUrl = url;

    this.router.navigateByUrl('/verify/survey');

    return false;
  }
}
